import {Error} from '@shared-components';
import {Component, ReactNode} from 'react';
import {useLocation} from 'react-router-dom';

interface ErrorBoundaryState {
  hasError: boolean;
}

interface ErrorBoundaryInnerProps {
  children: ReactNode;
}

class ErrorBoundaryInner extends Component<ErrorBoundaryInnerProps, ErrorBoundaryState> {
  public constructor(props: ErrorBoundaryInnerProps) {
    super(props);

    this.state = {
      hasError: false,
    };
  }

  public static getDerivedStateFromError(): ErrorBoundaryState {
    return {
      hasError: true,
    };
  }

  public render() {
    return <>{this.state.hasError ? <Error /> : this.props.children}</>;
  }
}

const ErrorBoundary: React.FC<ErrorBoundaryInnerProps> = ({children}) => {
  const {pathname} = useLocation();
  return <ErrorBoundaryInner key={pathname}>{children}</ErrorBoundaryInner>;
};

export default ErrorBoundary;
